module.exports = __webpack_public_path__ + "static/media/Badge_SvgSiteBienvenue_disabled.bdcea100.svg";